export const isValidArray = <Item = unknown>(
  value?: unknown
): value is Item[] => {
  return Array.isArray(value) && value.length >= 0;
};

export const randomize = <Item = unknown>(array: Item[]) => {
  return array.sort(() => Math.random() - 0.5);
};

// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_uniq
export const uniq = <Item = unknown>(arr: Item[] = []) => {
  return [...new Set(arr)];
};

export const groupBy = <Item, Key extends string>(
  items: Item[],
  fn: (item: Item) => Key
) => {
  const accumulator = {} as Record<Key, Item[]>;

  return items.reduce((acc, item) => {
    const groupKey = fn(item);
    return { ...acc, [groupKey]: [...(acc[groupKey] ?? []), item] };
  }, accumulator);
};

export const normalizeArrayOfString = (arr: unknown): string[] => {
  if (!arr || !Array.isArray(arr)) return [];

  return arr.filter((value) => typeof value === "string");
};
